import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeEvent } from 'shell/models/type-event';
import { TypesEventClient } from '../list/types';

export interface EventResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  typeEvents: Array<TypesEventClient>;
}

export const transformerTypeEvents = (
  response: AxiosResponse<HttpResponseList<TypeEvent>>
): EventResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    typeEvents: data.map((event: TypeEvent) => ({
      id: event?.codice.toString(),
      codice: event?.codice,
      descrizione: event?.descrizione,
    })),
  };
};
